import _assign from 'lodash/assign';
import ProductRegistrationForm from '@/utils/Forms/ProductRegistrationForm';
import {
  SET_WRAPPER_CLASS,
  SET_ACTIVE_STEP,
  SET_INPUT_TERM,
  SET_ACTIVE_TAB,
  SET_SUGGESTIONS,
  SET_INITIAL_CATEGORIES,
  CLEAN_CATEGORIES,
  UPDATE_SELECTED_CATEGORY,
  SET_CATEGORIES_LEVEL,
  SET_SEARCH,
  UNSET_SEARCH,
  SET_PRODUCTS_LOADING,
  UNSET_PRODUCTS_LOADING,
  SET_PRODUCTS,
  SET_USER_DETAILS,
  SET_SELECTED_PRODUCT,
  SET_PRODUCT_REG_GUID,
  SET_IS_CONFIRMATION,
  SET_HAS_MARKETING_CONSENT,
} from '@/product-registration/context/types';

export default (state, action) => {
  switch (action.type) {
    case SET_WRAPPER_CLASS:
      return {
        ...state,
        wrapperClass: action.payload,
      };
    case SET_ACTIVE_STEP:
      return {
        ...state,
        currentStep: action.payload,
        steps: state.steps.map(step => {
          step.active = step.num === action.payload;
          step.completed = step.num < action.payload;
          return step;
        }),
      };
    case SET_INPUT_TERM:
      return {
        ...state,
        inputTerm: action.payload,
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        tabs: state.tabs.map(tab => {
          tab.isActive = tab.id === action.payload;
          return tab;
        }),
      };
    case SET_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.payload,
      };
    case SET_INITIAL_CATEGORIES:
      return {
        ...state,
        categories: {
          1: action.payload,
        },
      };
    case UPDATE_SELECTED_CATEGORY:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.payload.level]: state.categories[action.payload.level].map(
            cat => {
              cat.selected = cat.code === action.payload.code;
              return cat;
            },
          ),
        },
      };
    case SET_CATEGORIES_LEVEL:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.payload.level]: state.categories[action.payload.level].map(
            cat => {
              cat.selected = cat.code === action.payload.code;
              return cat;
            },
          ),
          [action.payload.level + 1]: action.payload.data,
        },
        currentCategoryLevel: action.payload.level + 1,
      };
    case CLEAN_CATEGORIES:
      return {
        ...state,
        categories: null,
        currentCategoryLevel: 1,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: { ...action.payload },
      };
    case UNSET_SEARCH:
      return {
        ...state,
        search: { text: null, code: null },
      };
    case SET_PRODUCTS_LOADING:
      return {
        ...state,
        productsLoading: true,
      };
    case UNSET_PRODUCTS_LOADING:
      return {
        ...state,
        productsLoading: false,
      };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };
    case SET_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
        selectedProductForm: _assign(
          {},
          {
            ...ProductRegistrationForm,
            value: { ...ProductRegistrationForm.value, ...action.payload },
          },
        ),
      };
    case SET_PRODUCT_REG_GUID:
      return {
        ...state,
        productRegGuid: action.payload,
      };
    case SET_IS_CONFIRMATION:
      return {
        ...state,
        isConfirmation: action.payload,
      };
    case SET_HAS_MARKETING_CONSENT:
      return {
        ...state,
        hasMarketingConsent: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
